var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('aside',[_c('div',{staticClass:"guide",style:({ backgroundImage: _setup.backgroundImage })},[_c('h2',{staticClass:"guide__title"},[_vm._v(_vm._s(_setup.translate('eolp.banner.title')))]),_vm._v(" "),_c('p',{staticClass:"guide__description"},[_vm._v(_vm._s(_setup.translate('eolp.banner.content')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }